import { Injectable } from '@angular/core';
import { SessionType } from '@gk/gk-modules';
import { map, Observable } from 'rxjs';
import { MainRoutes } from '../../guards/guard.models';
import { PortalConfigGetter } from '../../services/portal-config/portal-config.interface';
import {
  defaultPortalConfig,
  PortalConfig,
} from '../../services/portal-config/portal-config.model';
import { WebPortalService } from '../../services/web-portal/web-portal.service';

@Injectable({
  providedIn: 'root',
})
export class CoordinationMeetingPortalProjectConfigService
  implements PortalConfigGetter
{
  constructor(private webPortalService: WebPortalService) {}

  getPortalConfig(): Observable<PortalConfig> {
    return this.webPortalService
      .getWebPortalDataByCurrentRoute(MainRoutes.CoordinationMeetingPortal)
      .pipe(
        map((webPortal) => ({
          ...defaultPortalConfig,
          isPerunAuthenticationAvailable: webPortal.ewidLogging,
          sessionTypes: [SessionType.PerunAuth],
          accessKeys: ['coordinationMeetingPortal'],
          portalId: webPortal.portalId,
          redirectCookieEnabled: true,
        })),
      );
  }
}
